// API Configuration
export const API_CONFIG = {
  // Override for local/dev: set `REACT_APP_API_BASE_URL` in `.env`
  // Example: REACT_APP_API_BASE_URL=http://192.168.1.47:5000/api
  BASE_URL:
    process.env.REACT_APP_API_BASE_URL || '',
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh',
      FORGOT_PASSWORD: '/auth/forgot-password',
      RESET_PASSWORD: '/auth/reset-password',
    },
    SCHOOL: {
      PROFILE: '/school/profile',
      UPDATE_PROFILE: '/school/profile',
      DASHBOARD: '/school/dashboard',
      DETAILS: '/schools/:schoolId/details',
      GET_PROFILE: '/schools/:schoolId/',
      UPDATE_PROFILE_BY_ID: '/schools/:schoolId/profile',
      STATS: '/schools/:schoolId/stats',
    },
    STUDENTS: {
      LIST: '/students',
      CREATE: '/students',
      UPDATE: '/students/:studentId',
      DELETE: '/students/:studentId',
      DETAILS: '/students/:studentId',
      BY_SCHOOL: '/students/school/:schoolId',
      BY_CLASS: '/students/:schoolId/class/:classId',
      GET_WITH_CLASS: '/students/getStudentWithClass/:studentId',
      PROMOTE_CLASS: '/students/promote-class',
      BULK_UPLOAD: '/students/bulk-upload',
      BULK_UPLOAD_TEMPLATE: '/students/bulk-upload/template',
    },
    TEACHERS: {
      LIST: '/teachers',
      CREATE: '/teachers',
      UPDATE: '/teachers/:id',
      UPDATE_BY_ID: '/teachers/update/:id',
      DELETE: '/teachers/:id',
      DELETE_BY_ID: '/teachers/delete/:id',
      DETAILS: '/teachers/:id',
      BY_SCHOOL: '/teachers/school/:schoolId',
      ADD: '/teachers',
      EDIT: '/teachers/:teacherId',
      DELETE_TEACHER: '/teachers/:teacherId',
    },
    TEACHER_PROFILE: {
      GET_PROFILE: '/teacher-admin/:schoolId/:teacherId/profile',
      UPDATE_TEACHER: '/teachers/:teacherId',
    },
    TEACHER_ATTENDANCE: {
      MARK: '/teacher-attendance/',
      GET_BY_DATE: '/teacher-attendance/:schoolId/date/:date',
      GET_MARKED_DATES: '/teacher-attendance/:schoolId/dates',
      DOWNLOAD_REPORT: '/teacher-attendance/teacher/download-report',
      SUMMARY: '/teacher-attendance/teacher/summary',
      GET_STATUS: '/teacher-attendance/teacher/:schoolId/:date/:teacherId',
      BULK_MARK: '/teacher-attendance/',
      // Fetch attendance summary for a specific teacher
      BY_TEACHER: '/teacher-attendance/:schoolId/attendance/teacher/:teacherId',
    },
    STUDENT_ATTENDANCE: {
      MARK: '/student-attendance/:schoolId/studentAttendance',
      GET_BY_DATE: '/student-attendance/:schoolId/studentAttendance/date/:date',
      GET_MARKED_DATES: '/student-attendance/:schoolId/studentAttendance/dates',
      DOWNLOAD_REPORT: '/student-attendance/studentAttendance/report',
      // Note: API expects schoolId first, then studentId
      GET_BY_STUDENT_MONTH: '/student-attendance/attendance/student/:schoolId/:studentId/by-month',
    },
    CLASSROOM: {
      GET_CLASSES: '/classrooms/:schoolId/classes',
      CREATE_CLASS: '/classrooms/:schoolId/classes',
      UPDATE_CLASS: '/classrooms/:schoolId/classes/:classId',
      DELETE_CLASS: '/classrooms/:schoolId/classes/:classId',
      GET_CLASS_BY_ID: '/classrooms/classes/:schoolId/:classId',
    },
    ATTENDANCE: {
      LIST: '/attendance',
      MARK: '/attendance/mark',
      REPORT: '/attendance/report',
    },
    EXAMS: {
      LIST: '/exams',
      CREATE: '/exams',
      UPDATE: '/exams/:id',
      DELETE: '/exams/:id',
      TIMETABLE: '/exams/timetable',
      // New Exam Timetable endpoints with school and academic year
      GET_TIMETABLES: '/exam-timetables/:schoolId/:yearId/examTimetable',
      GET_TIMETABLE: '/exam-timetables/:schoolId/:yearId/examTimetable/:timetableId',
      CREATE_TIMETABLE: '/exam-timetables/:schoolId/:yearId/examTimetable',
      UPDATE_TIMETABLE: '/exam-timetables/:schoolId/:yearId/examTimetable/:timetableId',
      DELETE_TIMETABLE: '/exam-timetables/:schoolId/:yearId/examTimetable/:timetableId',
      DELETE_SUBJECT: '/exam-timetables/:schoolId/:yearId/examTimetable/:timetableId/subject/:subjectId',
      // Get exam timetables by class
      GET_BY_CLASS: '/exam-timetables/:schoolId/class/:classId/exam-timetable',
    },
    STUDENT_PAYMENTS: {
      SUMMARY_BY_SCHOOL: '/student-payments/school/:schoolId/summary',
      DOWNLOAD_CLASS_REPORT: '/student-payments/reports/class-wise',
      DOWNLOAD_STUDENT_REPORT: '/student-payments/reports/student-receipt',
      ADD_PAYMENT: '/student-payments/:schoolId/payments',
      GET_STUDENT_PAYMENTS: '/student-payments/:schoolId/students/:studentId',
      DELETE_PAYMENTS: '/student-payments/:schoolId/students/:studentId/payments',
      UPDATE_PAYMENT: '/student-payments/:schoolId/students/:studentId/payments/:paymentId',
      GET_PAYMENT: '/student-payments/:schoolId/students/:studentId/payments/:paymentId',
      ALL_SCHOOL_PAYMENTS: '/student-payments/school/:schoolId/all-payments',
      STATISTICS: '/student-payments/school/:schoolId/statistics',
    },
    ANNOUNCEMENTS: {
      GET_BY_SCHOOL: '/announcements/:schoolId/announcements',
      CREATE_ANNOUNCEMENT: '/announcements/:schoolId/announcements',
      UPDATE_ANNOUNCEMENT: '/announcements/:schoolId/announcements/:announcementId',
      DELETE_ANNOUNCEMENT: '/announcements/:schoolId/announcements/:announcementId',
      // Get announcements by class or teacher for teacher admin
      GET_BY_CLASS_OR_TEACHER: '/announcements/:schoolId/announcements/filter/:classId/:teacherId',
    },
    SUBSCRIPTIONS: {
      GET_BY_SCHOOL: '/subscriptions/school/:schoolId',
      CREATE: '/subscriptions/',
      GET_COST: '/subscriptions/subscription-cost',
      GET_CURRENT: '/subscriptions/current/:schoolId',
      CAN_ADD_STUDENTS: '/subscriptions/can-add-students/:schoolId',
      DOWNLOAD_INVOICE: '/subscriptions/download-invoice',
      SCHOOL_CUSTOM_PLANS: '/subscriptions/school-custom-plans/:schoolId',
    },
    SUBSCRIPTION_PLANS: {
      GET_CURRENT: '/master-admin/subscription-plans/current',
    },
    PAYMENT_GATEWAY: {
      RAZORPAY: {
        CREATE_ORDER: '/payment-gateway/razorpay/create-order',
        VERIFY_PAYMENT: '/payment-gateway/razorpay/verify-payment',
      },
    },
    FEES: {
      LIST: '/fees',
      CREATE: '/fees',
      UPDATE: '/fees/:id',
      DELETE: '/fees/:id',
      PAYMENT: '/fees/payment',
      DASHBOARD: '/fees/:schoolId/years/:yearId/dashboard',
      SUMMARY: '/fees/:schoolId/years/:yearId/summary/:feeTypeId',
      STRUCTURE: '/fees/:schoolId/years/:yearId/structure/:feeTypeId',
      PAYMENTS: '/fees/:schoolId/years/:yearId/payments',
      EXPORT: '/fees/:schoolId/years/:yearId/reports/export',
    },
    EVENTS: {
      CREATE: '/events/:schoolId/events',
      GET_ALL: '/events/events/:schoolId',
      GET_BY_ID: '/events/events/:schoolId/:eventId',
      UPDATE: '/events/:schoolId/events/:eventId',
      DELETE: '/events/events/:schoolId/:eventId',
      DELETE_MULTIPLE: '/events/delete-multiple/:schoolId',
      // Get events for teacher admin
      GET_EVENTS: '/events/events/:schoolId',
    },
    QUESTION_PAPERS: {
      GET_CLASSES: '/question-papers/classes',
      GET_PAPERS: '/question-papers/:classId/:testType',
    },
    GENERATED_QUESTION_PAPERS: {
      LIST: '/generated-question-papers/:schoolId/current/papers',
      GET: '/generated-question-papers/:schoolId/current/papers/:paperId',
      CREATE: '/generated-question-papers/:schoolId/current/papers',
      UPDATE: '/generated-question-papers/:schoolId/current/papers/:paperId',
      DELETE: '/generated-question-papers/:schoolId/current/papers/:paperId',
      DUPLICATE: '/generated-question-papers/:schoolId/current/papers/:paperId/duplicate',
      ARCHIVE: '/generated-question-papers/:schoolId/current/papers/:paperId/archive',
      VERSIONS: '/generated-question-papers/:schoolId/current/papers/:paperId/versions',
      UPLOAD_IMAGE: '/generated-question-papers/:schoolId/upload-image',
      QUESTION_BANK: '/generated-question-papers/:schoolId/question-bank',
    },
    HOMEWORKS: {
      CREATE: '/homeworks/:schoolId/homeworks',
      GET_BY_DATE: '/homeworks/:schoolId/homeworks/date/:date',
      GET_DATES: '/homeworks/:schoolId/homeworks/dates',
      UPDATE: '/homeworks/:schoolId/homeworks/:homeworkId',
      DELETE: '/homeworks/:schoolId/homeworks/:homeworkId',
      // Student homework endpoints
      GET_BY_CLASS_DATE: '/homeworks/homework/class/:schoolId/:date',
      GET_HOMEWORK_DATES: '/homeworks/homework/dates/:schoolId',
    },
    TEACHER_LEAVES: {
      CREATE: 'teacher-leaves/:schoolId/leaves',
      UPDATE: 'teacher-leaves/:schoolId/leaves/:leaveId',
      DELETE: 'teacher-leaves/:schoolId/leaves/:leaveId',
      GET_ALL: 'teacher-leaves/:schoolId/leaves',
      GET_BY_TEACHER: 'teacher-leaves/:schoolId/leaves/teacher/:teacherId',
      GET_BY_ID: 'teacher-leaves/:schoolId/leaves/:leaveId',
      UPDATE_STATUS: 'teacher-leaves/:schoolId/leaves/:leaveId/status',
    },
    STUDENT_LEAVES: {
      CREATE: '/student-leaves/:schoolId/leaves',
      GET_BY_STUDENT: '/student-leaves/:schoolId/leaves/student/:studentId',
      GET_BY_CLASS: '/student-leaves/:schoolId/class/:classId/leaves',
      UPDATE: '/student-leaves/:schoolId/leaves/:leaveId',
      DELETE: '/student-leaves/:schoolId/leaves/:leaveId',
      GET_BY_ID: '/student-leaves/:schoolId/leaves/:leaveId',
      UPDATE_STATUS: '/student-leaves/:schoolId/leaves/:leaveId/status',
      GET_ALL_BY_SCHOOL: '/student-leaves/:schoolId/leaves/all',
    },
    RESULTS: {
      GET_BY_SCHOOL: "/results/school/:schoolId",
      GET_BY_CLASS: "/results/school/:schoolId/class/:classId",
      GET_BY_STUDENT: "/results/school/:schoolId/student/:studentId",
      GET_BY_ID: "/results/school/:schoolId/result/:resultId",
      CREATE: "/results/school/:schoolId",
      UPDATE: "/results/school/:schoolId/result/:resultId",
      DELETE: "/results/school/:schoolId/result/:resultId",
      STATISTICS: "/results/school/:schoolId/class/:classId/statistics",
      DOWNLOAD_REPORT: "/results/school/:schoolId/class/:classId/report",
    },
    STUDENT_RESULTS: {
      CREATE: "/student-results/",
      GET_BY_STUDENT_CLASS: "/student-results/:schoolId/student/:studentId/class/:classId",
      GET_ALL_BY_STUDENT: "/student-results/:schoolId/student/:studentId/all",
      UPDATE: "/student-results/:schoolId/:resultId",
      DELETE: "/student-results/:schoolId/:resultId",
      DOWNLOAD: "/student-results/:schoolId/results/:resultId/download",
    },
    CLASS_SCHEDULES: {
      CREATE: '/class-schedules/:schoolId/:classId/schedules',
      GET_ALL: '/class-schedules/:schoolId/:classId/schedules',
      GET_BY_ID: '/class-schedules/:schoolId/:classId/schedules/:scheduleId',
      UPDATE: '/class-schedules/:schoolId/:classId/schedules/:scheduleId',
      DELETE: '/class-schedules/:schoolId/:classId/schedules/:scheduleId',
    },
    FEE_TYPES: {
      ACTIVE: '/fee-types/active',
      SCHOOL: '/fee-types/school/:schoolId',
    },
    MISC_FEES: {
      ADMISSION: '/student-admissions/:schoolId/:studentId',
      UNIFORM: '/student-uniform-fees/get',
      BAG: '/student-bag-fees/get',
      BOOK: '/book-fees/student/:schoolId',
    },
  },
};
